import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  IconButton,
  Typography,
} from "@mui/material";
import CLOSE_ICON from "../../images/close.svg";

const styles = {
  container: {
    position: "absolute",
    top: "56px",
    right: "-24px",
    background: "#fff",
    borderRadius: "12px 0 0 12px",
    maxWidth: "312px",
    width: "312px",
    height: "calc(100vh - 72px)",
  },
};

const BLANK_IMAGE =
  "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

const ExploreDesigns = ({
  grid,
  selectedDesignId,
  setOpenMenu,
  onDesignSelect,
}) => {
  return (
    <Card
      sx={{
        ...styles.container,
        zIndex: 999,
      }}
      className="scale-in-right-animation"
    >
      <CardHeader
        sx={{ padding: "12px 24px" }}
        title={
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              color: "#0D0F14",
              fontSize: "14px",
              fontWeight: 600,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
            }}
          >
            Explore Designs
          </Box>
        }
        action={
          <>
            <IconButton aria-label="close" onClick={() => setOpenMenu("")}>
              <img src={CLOSE_ICON} alt="Close" />
            </IconButton>
          </>
        }
      />
      <CardContent
        className="iframe-container"
        sx={{
          height: "calc(100% - 92px)",
          position: "relative",
          padding: "12px 16px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          overflow: "auto",
        }}
      >
        {!grid?.linkedWebTours?.length && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <Typography variant="body2" sx={{ color: "#0D0F14" }}>
              No designs available
            </Typography>
          </div>
        )}
        {grid?.linkedWebTours?.map((d) => {
          const urlCategoryMap = d.productThumbnails?.reduce((result, next) => {
            result[next.category] = next.url;
            return result;
          }, {});
          return (
            <Card
              key={d.designId}
              sx={{
                maxWidth: 345,
                borderRadius: "7px",
                border: `1px solid ${
                  d.designId === selectedDesignId ? "#240046" : "#E2E5EC"
                }`,
                flexShrink: 0,
                background: "#FFF",
                boxShadow: "none",
                "& .MuiCardActionArea-focusHighlight": {
                  opacity: "0 !important",
                },
                "&:hover": {
                  boxShadow:
                    "0px 2.951px 4.426px -0.738px rgba(10, 13, 18, 0.10), 0px 1.475px 2.951px -1.475px rgba(10, 13, 18, 0.06)",
                  "& .MuiCardActionArea-focusHighlight": {
                    opacity: "0 !important",
                  },
                },
              }}
              onClick={() => onDesignSelect(d)}
            >
              <CardActionArea>
                <CardMedia
                  component="img"
                  height="145"
                  image={urlCategoryMap.flooring || BLANK_IMAGE}
                  alt="Design Images"
                />
                <CardContent sx={{ p: "8px 16px !important" }}>
                  <div style={{ position: "relative" }}>
                    <span
                      style={{
                        borderRadius: "4px 4px 0 0",
                        position: "absolute",
                        top: "-121px",
                        left: "0px",
                        height: "112px",
                        width: "76px",
                        background: `url(${urlCategoryMap.cabinets}) lightgray no-repeat right top`,
                        backgroundSize: "cover",
                        border: "1px solid white",
                      }}
                    ></span>
                    <span
                      style={{
                        borderRadius: "4px 4px 0 0",
                        position: "absolute",
                        top: "-59px",
                        left: "47px",
                        height: "50px",
                        width: "215px",
                        background: `url(${urlCategoryMap.countertop}) lightgray no-repeat right top`,
                        backgroundSize: "cover",
                        border: "1px solid white",
                      }}
                    ></span>
                    <span
                      style={{
                        borderRadius: "50%",
                        position: "absolute",
                        top: "-130px",
                        left: "150px",
                        height: "50px",
                        width: "50px",
                        backgroundColor: `${
                          urlCategoryMap.paint || "lightgray"
                        }`,
                        border: "1px solid white",
                      }}
                    ></span>
                    <span
                      style={{
                        borderRadius: "4px",
                        position: "absolute",
                        top: "-103px",
                        left: "92px",
                        height: "68px",
                        width: "68px",
                        background: `url(${urlCategoryMap.backsplash}) lightgray no-repeat right top`,
                        backgroundSize: "cover",
                        border: "1px solid white",
                      }}
                    ></span>
                  </div>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#0D0F14",
                      fontWeight: "500",
                      fontSize: "12px",
                    }}
                  >
                    {d.webTourName}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          );
        })}
      </CardContent>
    </Card>
  );
};

export default ExploreDesigns;
